document.getElementById('gNavBtn').addEventListener('click', function() {
  const attr = this.getAttribute('data-open');
  this.setAttribute('data-open', attr == "0" ? "1" : "0");
  document.getElementById('hideGNav').setAttribute('data-open', attr == "0" ? "1" : "0");
  document.body.setAttribute('data-open', attr == "0" ? "1" : "0");
});

window.addEventListener('DOMContentLoaded', function() {
  
  initializeSliders();
  window.addEventListener("resize", initializeSliders);
  
  initializeCollectionVisuals();
  window.addEventListener("resize", initializeCollectionVisuals);
  
  initializeVisuals();
  
  var fixAndSlideElements = document.querySelectorAll('.fixAndSlide');
  var lastScrollPosition = window.pageYOffset;

  function toggleClassesAndSetImgHeight(scrollDirection) {
    fixAndSlideElements.forEach(function(fixAndSlide) {
    const ttlElement = fixAndSlide.querySelector('.ttl');
    const fixElement = fixAndSlide.querySelector('.fix');
    const sceenElements = fixAndSlide.querySelectorAll('.sceen');

    if (!fixElement&&!ttlElement) return;

    const rect = fixAndSlide.getBoundingClientRect();
    if(fixElement) {
      if (rect.top <= 0) {
        fixElement.classList.add('stay');
      } else {
        fixElement.classList.remove('stay');
      }

      if (rect.bottom <= window.innerHeight) {
        if(!(fixAndSlide.dataset.fixBackground == '1' && fixAndSlide.dataset.fixBackgroundLast !== '1')) fixElement.classList.add('go');
      } else {
        fixElement.classList.remove('go');
      }
    }

    sceenElements.forEach(function(sceen,index) {
      const imgElement = sceen.querySelector('.img');
      const sceenRect = sceen.getBoundingClientRect();
      if(index===0) imgElement.classList.add('first');

      if (rect.top <= 0) {
      imgElement.classList.add('stay');
      } else {
      imgElement.classList.remove('stay');
      }

      if (rect.bottom <= window.innerHeight) {
        if(!(fixAndSlide.dataset.fixBackground == '1' && fixAndSlide.dataset.fixBackgroundLast !== '1')) imgElement.classList.add('go');
      } else {
        imgElement.classList.remove('go');
      }

      const visibleHeightPercentage = Math.max(0, Math.min(1, sceenRect.top / window.innerHeight));
      imgElement.style.height = `${100 - visibleHeightPercentage * 100}vh`;
    });
    if(ttlElement) {
      const children = ttlElement.children;
      
      for (let i = 0; i < children.length; i++) {
        children[i].style.transitionDelay = `${0.05 * i}s`;
      }
      if(ttlElement.classList.contains('wave-in')) {
        if (rect.top <= window.innerHeight - ttlElement.offsetHeight) {
          ttlElement.classList.add('do');
        } else {
          ttlElement.classList.remove('do');
        }
      }
    }
    });
  }

  window.addEventListener('scroll', function() {
    var currentScrollPosition = window.pageYOffset;
    var scrollDirection = currentScrollPosition > lastScrollPosition ? 1 : -1;
    lastScrollPosition = currentScrollPosition;
    toggleClassesAndSetImgHeight(scrollDirection);
  });
  toggleClassesAndSetImgHeight(0);

  fixAndSlideElements.forEach(function(fixAndSlide) {
    const sceenElements = fixAndSlide.querySelectorAll(':scope > .sceen');
    
    if(sceenElements.length>1) {
    
    let currentIndex = 0;

    // Create dot navigation HTML
    let dotNavHTML = '<div class="dot-nav">';
    for (let i = 0; i < sceenElements.length; i++) {
      dotNavHTML += `<div class="dot" data-index="${i}"></div>`;
    }
    dotNavHTML += '</div>';

    // Insert dot navigation into .fixAndSlide
    fixAndSlide.insertAdjacentHTML('beforeend', dotNavHTML);

    // Update dot navigation
    function updateDotNav() {
      let dots = fixAndSlide.querySelectorAll('.dot');
      dots.forEach(dot => dot.classList.remove('selected'));
      dots[currentIndex].classList.add('selected');
    }

    // Initialize dot navigation
    updateDotNav();

    function moveRight() {
      currentIndex = Math.max(currentIndex - 1, 0);
      var transformX = -100 * currentIndex;
      sceenElements.forEach(function(sceen) {
        sceen.style.transform = `translateX(${transformX}%)`;
      });
      updateDotNav();
    }

    function moveLeft() {
      currentIndex = Math.min(currentIndex + 1, sceenElements.length - 1);
      var transformX = -100 * currentIndex;
      sceenElements.forEach(function(sceen) {
        sceen.style.transform = `translateX(${transformX}%)`;
      });
      updateDotNav();
    }

    fixAndSlide.addEventListener('touchstart', function(e) {
      startX = e.changedTouches[0].pageX;
    });

    fixAndSlide.addEventListener('touchend', function(e) {
      let endX = e.changedTouches[0].pageX;
      var distance = startX - endX;

      // Ignore swipe if distance is less than 50px
      if (Math.abs(distance) < 50) return;

      var direction = distance > 0 ? -1 : 1; // If swiped left, direction is -1. If right, direction is 1
      direction === 1 ? moveRight() : moveLeft();
    });

    const nextElement = fixAndSlide.querySelector('.next');
    const prevElement = fixAndSlide.querySelector('.prev');

    if(nextElement) {
      nextElement.addEventListener('click',function(e) {
      e.preventDefault();
      moveLeft();
      return false;
      });
    }

    if(prevElement) {
      prevElement.addEventListener('click',function(e) {
      e.preventDefault();
      moveRight();
      return false;
      });
    } 
    }
  });
  
  const searchBtn = document.querySelector('a[href="#searchBoxWrap"]');
  const searchWrap = document.getElementById('searchWrap');
  const searchBox = document.getElementById('searchBox');
  const resultsContainer = document.getElementById('results');

  if (searchBtn && searchWrap) {
    searchBtn.onclick = function () {
      searchWrap.classList.add('open');
      document.body.setAttribute('data-open', '1');
      searchBox && searchBox.focus();
    };
    const searchCloseBtn = document.getElementById('searchCloseBtn');
    if (searchCloseBtn) {
      searchCloseBtn.onclick = function () {
        searchWrap.classList.remove('open');
        document.body.setAttribute('data-open', '0');
      };
    }
  }

  let timeout = null;

  // デバウンス付きインプット監視
  if (searchBox) {
    searchBox.addEventListener('input', function () {
      clearTimeout(timeout);
      const q = searchBox.value.trim();

      if (q.length > 0) {
        resultsContainer.innerHTML = '';
        resultsContainer.classList.add('searching');

        timeout = setTimeout(() => {
          searchProducts(q);
        }, 450);
      } else {
        resultsContainer.innerHTML = '';
        resultsContainer.classList.remove('searching');
      }
    });
  }

  // HTMLエスケープ（タイトル用）
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // 画像URLに幅パラメータを付与（Shopify CDN）
  function withWidth(url, width) {
    if (!url) return '';
    const hasQuery = url.includes('?');
    return url + (hasQuery ? '&' : '?') + 'width=' + width;
  }

  // ★ Shopify 予測検索APIで商品を検索
  function searchProducts(query) {
    const url = `/search?view=autocomplete-json&q=${encodeURIComponent(query)}&type=product`;

    fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(data => displayResults(data.products || []))
      .catch(err => {
        console.error('Search error:', err);
        resultsContainer.classList.remove('searching');
        resultsContainer.innerHTML = '<p id="noresults">An error occurred.</p>';
      });
  }

  // 検索結果を描画
  function displayResults(products) {
    resultsContainer.innerHTML = '';
    resultsContainer.classList.remove('searching');

    if (!products.length) {
      resultsContainer.innerHTML = '<p id="noresults">NO RESULTS WERE FOUND.</p>';
      return;
    }

    // 必要ならクライアント側でタイトル昇順に
    products.sort((a, b) => {
      const at = (a?.title || '').toLowerCase();
      const bt = (b?.title || '').toLowerCase();
      return at.localeCompare(bt);
    });

    const list = document.createElement('ul');

    products.forEach(p => {
      const url = p?.url || '#';
      const title = p?.title ? escapeHtml(p.title) : 'No title';
      // predictive search の image は {url, alt} が基本
      const imgUrl = p?.image || '';
      const li = document.createElement('li');

      li.innerHTML = `
        <a href="${url}">
          ${imgUrl ? `<img src="${imgUrl}" width="200" height="200" alt="${escapeHtml(p?.image?.alt || title)}">` : ''}
          ${title}
        </a>
      `;
      list.appendChild(li);
    });

    resultsContainer.appendChild(list);
  }
  
  if( document.getElementById('holidayLink')&&document.getElementById('holidayInfo')) {
    document.getElementById('holidayLink').onclick = function () {
      document.getElementById('holidayInfo').classList.add('disp');
    };
    document.querySelector('#holidayInfo .close').onclick = function () {
      document.getElementById('holidayInfo').classList.remove('disp');
    };
  }
});

function initializeSliders() {
  let init = false;
  const sliders = document.querySelectorAll(".productList.slider");
  
  sliders.forEach((slider) => {
    const prevButton = slider.nextElementSibling.classList.contains("prev")
      ? slider.nextElementSibling
      : null;
    const nextButton = slider.nextElementSibling.nextElementSibling.classList.contains("next")
      ? slider.nextElementSibling.nextElementSibling
      : null;

    let currentIndex = 0;
    let itemWidth;

    function setupSlider() {
      const items = slider.querySelectorAll("li");
      itemWidth = items[0].offsetWidth;

      const isPC = window.innerWidth >= 769;
      const minItemsToShowSlider = isPC ? 5 : 3;
      const maxIndex = items.length - (isPC ? 4 : 2);

      if (items.length < minItemsToShowSlider) {
        prevButton.style.display = "none";
        nextButton.style.display = "none";
        return;
      } else {
        prevButton.style.display = "block";
        nextButton.style.display = "block";
      }

      prevButton.onclick = function () {
        currentIndex = Math.max(currentIndex - 1, 0);
        updateSlider();
      };

      nextButton.onclick = function () {
        currentIndex = Math.min(currentIndex + 1, maxIndex);
        updateSlider();
      };

      
      if(!init) {
      
        let startX, startY, isDragging = false;
        slider.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isDragging = true;
          slider.style.transition = "none"; // Disable transition during swipe
        }, { passive: false });

        slider.addEventListener('touchmove', function (e) {
          if (!isDragging) return;
          const x = e.touches[0].clientX;
          const y = e.touches[0].clientY;
          const diffX = startX - x;
          const diffY = startY - y;

          // 横方向の動きが縦方向の動きより大きい場合のみ、スライダーを動かす
          if (Math.abs(diffX) > Math.abs(diffY)) {
            e.preventDefault(); // ブラウザのスクロールを防ぐ
            slider.style.transform = `translateX(${-currentIndex * itemWidth - diffX}px)`;
          }
        }, { passive: false });

        slider.addEventListener('touchend', function (e) {
          if (!isDragging) return;
          isDragging = false;
          const endX = e.changedTouches[0].clientX;
          const diffX = startX - endX;
          const slideAmount = diffX > 0 ? 1 : -1;

          if (Math.abs(diffX) > 50) { // ここでスライドするしきい値を設定
            currentIndex += slideAmount;
            currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
          }
          slider.style.transition = "transform 0.25s ease-in-out"; // Enable transition again
          updateSlider();
        }, { passive: false });
      }

      updateSlider();
    }

    function updateSlider() {
      const items = slider.querySelectorAll("li");
      itemWidth = items[0].offsetWidth;
      slider.style.transform = `translateX(${-currentIndex * itemWidth}px)`;
      slider.style.transition = "transform 0.25s ease-in-out"; // Enable transition
      updateButtons();
    }

    function updateButtons() {
      prevButton.style.visibility = currentIndex === 0 ? "hidden" : "visible";
      nextButton.style.visibility = currentIndex === slider.querySelectorAll("li").length - (window.innerWidth >= 769 ? 4 : 2) ? "hidden" : "visible";
    }

    // Initialize and setup event listeners
    setupSlider();
    window.addEventListener('resize', setupSlider);
  });
}

function initializeCollectionVisuals() {
  const sliders = document.querySelectorAll(".collectionVisuals");
  
  sliders.forEach((slider) => {
    const prevButton = slider.nextElementSibling.classList.contains("prev")
      ? slider.nextElementSibling
      : null;
    const nextButton = slider.nextElementSibling.nextElementSibling.classList.contains("next")
      ? slider.nextElementSibling.nextElementSibling
      : null;

    let currentIndex = 0;
    let itemWidth;
    let items;

    slider.addEventListener('click', function() {
      
      if(slider.dataset.modal!='true'&&window.innerWidth >= 769) {
        
        slider.dataset.modal = 'true';
        const container = slider.parentElement;

        // .modalWrapを作成
        var collectionVisualsModal = document.createElement('div');
        collectionVisualsModal.classList.add('collectionVisualsModal');
        document.body.appendChild(collectionVisualsModal);
        document.documentElement.style.overflow = 'hidden';

        const placeholder = document.createElement('div');
        placeholder.classList.add('placeholder');
        container.insertBefore(placeholder, slider);
        collectionVisualsModal.appendChild(slider);
        if (prevButton) collectionVisualsModal.appendChild(prevButton);
        if (nextButton) collectionVisualsModal.appendChild(nextButton);

        window.setTimeout(function(){ collectionVisualsModal.classList.add('visible'); },1);
          initializeSliders();
        window.setTimeout(function(){
        },250);
        window.setTimeout(function(){
        },500);

        // モーダルをクリックで閉じるイベントリスナーを追加
        collectionVisualsModal.addEventListener('click', function(event) {
          if (event.target !== nextButton && event.target !== prevButton) {
            event.stopPropagation();
            collectionVisualsModal.classList.remove('visible');
              document.documentElement.style.overflow = '';

            const placeholder = document.querySelector('.placeholder');
            container.insertBefore(slider, placeholder);
            if (prevButton) container.insertBefore(prevButton, slider.nextSibling);
            if (nextButton) container.insertBefore(nextButton, prevButton.nextSibling);
            placeholder.remove();
            window.setTimeout(function(){
              document.body.removeChild(collectionVisualsModal);
              delete slider.dataset.modal;
              initializeSliders();
            },250);
          }
        });
      }
    });


    function setupSlider() {
      items = slider.querySelectorAll("li");
      itemWidth = items[0].offsetWidth;
      if(slider.dataset.modal=='true') itemWidth = '100vw';

      const isPC = window.innerWidth >= 769;
      const minItemsToShowSlider = isPC ? 2 : 2;
      const maxIndex = items.length - (isPC ? 1 : 1);

      if (items.length < minItemsToShowSlider) {
        prevButton.style.display = "none";
        nextButton.style.display = "none";
        return;
      } else {
        prevButton.style.display = "block";
        nextButton.style.display = "block";
      }

      prevButton.onclick = function () {
        currentIndex = Math.max(currentIndex - 1, 0);
        updateSlider();
      };

      nextButton.onclick = function () {
        currentIndex = Math.min(currentIndex + 1, maxIndex);
        updateSlider();
      };

      let startX;
      slider.ontouchstart = function (e) {
        startX = e.touches[0].clientX;
        slider.style.transition = "none"; // Disable transition during swipe
      };

      slider.ontouchmove = function (e) {
        const x = e.touches[0].clientX;
        const diffX = startX - x;
        document.documentElement.style.setProperty('--sliderPos', (currentIndex * itemWidth + diffX) + 'px');
        slider.dataset.grip = 'true';
        slider.style.transform = `translateX(${-currentIndex * itemWidth - diffX}px)`;
      };

      slider.ontouchend = function (e) {
        const endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;
        const slideAmount = diffX > 0 ? 1 : -1;
        if (Math.abs(diffX) > 20) {
          currentIndex += slideAmount;
          currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
        }
        slider.style.transition = "transform 0.25s ease-in-out"; // Enable transition again
        updateSlider();
      };

      updateSlider();
    }

    function updateSlider() {
      items = slider.querySelectorAll("li");
      itemWidth = items[0].offsetWidth;
      slider.dataset.grip = 'true';
      window.setTimeout(function(){ delete slider.dataset.grip; }, 250)
      if(slider.dataset.modal=='true') {
        document.documentElement.style.setProperty('--sliderPos', (currentIndex * 100) + 'vw');
        slider.style.transform = `translateX(${-currentIndex * 100}vw)`;
      } else {
        document.documentElement.style.setProperty('--sliderPos', (currentIndex * itemWidth) + 'px');
        prevButton.style.transform = `translateY(${-(items[currentIndex].offsetHeight / 2 - 20)}px)`;
        nextButton.style.transform = `translateY(${-(items[currentIndex].offsetHeight / 2 - 20)}px)`;
        slider.style.transform = `translateX(${-currentIndex * itemWidth}px)`;
      }
      slider.style.transition = "transform 0.25s ease-in-out, height 0.25s ease-in-out";
      slider.dataset.nav = (currentIndex+1) + '/' + items.length;
      slider.style.height = items[currentIndex].offsetHeight + 'px';
      updateButtons();
    }

    function updateButtons() {
      prevButton.style.visibility = currentIndex === 0 ? "hidden" : "visible";
      nextButton.style.visibility = currentIndex === slider.querySelectorAll("li").length - (window.innerWidth >= 769 ? 1 : 1) ? "hidden" : "visible";
    }

    // Initialize and setup event listeners
    setupSlider();
    window.addEventListener('resize', initializeSliders);
  });
}

function initializeVisuals() {
  const sliders = document.querySelectorAll(".visualViewer");
  const thumbs = document.querySelectorAll(".visualThumbs");
  
  sliders.forEach((slider, index) => {
    let init = false;
    const prevButton = slider.nextElementSibling.classList.contains("prev")
      ? slider.nextElementSibling
      : null;
    const nextButton = slider.nextElementSibling.nextElementSibling.classList.contains("next")
      ? slider.nextElementSibling.nextElementSibling
      : null;

    let currentIndex = 0;
    let itemWidth;

    function setupSlider() {
      const items = slider.querySelectorAll("li");
      itemWidth = items[0].offsetWidth;
      slider.style.width = (100 * items.length) + '%';
      items.forEach((item, index) => {
        item.style.minWidth = (100 / items.length) + '%';
      });

      const isPC = window.innerWidth >= 769;
      const minItemsToShowSlider = 2;
      const maxIndex = items.length - 1;

      if (items.length < minItemsToShowSlider) {
        prevButton.style.display = "none";
        nextButton.style.display = "none";
        return;
      } else {
        prevButton.style.display = "block";
        nextButton.style.display = "block";
      }

      prevButton.onclick = function () {
        currentIndex = Math.max(currentIndex - 1, 0);
        updateSlider();
      };

      nextButton.onclick = function () {
        currentIndex = Math.min(currentIndex + 1, maxIndex);
        updateSlider();
      };
      
      if (thumbs[index]) {
        thumbs[index].querySelectorAll('li').forEach((thumb, index) => {
          thumb.onclick = function () {
            currentIndex = Math.max(index, 0);
            updateSlider();
            updateButtons();
          };
        });
      }
      
      if(!init) {
      
        let startX, startY, isDragging = false;
        slider.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isDragging = true;
          slider.style.transition = "none"; // Disable transition during swipe
        }, {passive: true});

        slider.addEventListener('touchmove', function (e) {
          if (isDragging) {
            const x = e.touches[0].clientX;
            const y = e.touches[0].clientY;
            const diffX = startX - x;
            const diffY = startY - y;
            slider.style.transform = `translateX(${-currentIndex * itemWidth - diffX}px)`;
            if (Math.abs(diffX) > Math.abs(diffY)) {
              e.preventDefault(); 
            }
           }
        }, {passive: false});

        slider.addEventListener('touchend', function (e) {
          if (isDragging) {
            isDragging = false;
            const endX = e.changedTouches[0].clientX;
            const diffX = startX - endX;
            const slideAmount = diffX > 0 ? 1 : -1;
            if (Math.abs(diffX) > 50) {
              currentIndex += slideAmount;
              currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
            }
            slider.style.transition = "transform 0.25s ease-in-out"; // Enable transition again
            updateSlider();
           }
        }, {passive: true});
        init = true;
      
        if (thumbs[index]) {
          const sliderInfo = document.createElement('p');
          sliderInfo.className = 'sliderInfo';
          thumbs[index].parentNode.insertBefore(sliderInfo, thumbs[index]);
        }
       }

      updateSlider();
    }

    function updateSlider() {
      const items = slider.querySelectorAll("li");
      itemWidth = items[0].offsetWidth;
      if (thumbs[index]) {
        if(thumbs[index].querySelector('li.current')) thumbs[index].querySelector('li.current').classList.remove('current');
        thumbs[index].querySelector('li:nth-child('+(currentIndex+1)+')').classList.add('current');
        let thumbsOffset = 0;
        let thumbsMax = 12;
        let thumbsLength = thumbs[index].querySelectorAll('li').length;
        if(thumbsMax < thumbsLength) {
          let thumbsOffsetMax = thumbsLength-(thumbsMax/2);
          if(currentIndex>=thumbsOffsetMax) {
            thumbsOffset = thumbsLength - thumbsMax;
          } else if(currentIndex>=6) {
            thumbsOffset = currentIndex - (thumbsMax/2);
          }
          thumbs[index].style.transform = `translateX(calc(-100% / 12 * ${thumbsOffset}))`;
        }
      }
      slider.style.transform = `translateX(${-currentIndex * itemWidth}px)`;
      slider.style.transition = "transform 0.25s ease-in-out";
      const prevElement = thumbs[index].previousElementSibling;
      if (prevElement && prevElement.classList.contains('sliderInfo')) {
        prevElement.textContent = (currentIndex+1) + ' / ' + items.length;
      }
      updateButtons();
    }

    function updateButtons() {
      prevButton.style.visibility = currentIndex === 0 ? "hidden" : "visible";
      nextButton.style.visibility = currentIndex === slider.querySelectorAll("li").length - 1 ? "hidden" : "visible";
    }

    // Initialize and setup event listeners
    setupSlider();
    window.addEventListener('resize', setupSlider);
  });
}

// すべてのtextarea要素を取得
const textareas = document.querySelectorAll('textarea');

// textareaの高さを調整する関数
function adjustHeight(textarea) {
  // スタイルを一旦リセットしてスクロール高を取得
  textarea.style.height = 'auto';
  // 新しい高さを設定
  textarea.style.height = `calc(${textarea.scrollHeight}px)`;
}

// 各textareaに対してイベントリスナーを設定
textareas.forEach(textarea => {
  textarea.addEventListener('input', () => adjustHeight(textarea));
  // 初期ロード時に高さを調整
  adjustHeight(textarea);
});


// 汎用スワイプ・スナップカルーセル（.productList と #productDetail > ul.img 両対応）
(() => {
  const breakpoint = 769;        // 769px以上=PC

  const snapDurationMs = 300;
  const dragDistanceThreshold = 20;  // px
  const velocityThreshold = 0.5;     // px/ms
  const inertiaFactor = 220;         // 慣性距離 = 速度 * 係数
  const sampleWindowMs = 120;        // 速度測定の窓
  const clickThreshold = 6;          // px

  // バウンス系
  const edgeElasticity = 0.35;
  const overshootMin = 18;
  const overshootMax = 60;
  const overshootK   = 400;
  const overshootOutMs = 140;
  const overshootBackMs = 220;

  // 対象トラックを収集（既存・新規両方）
  const tracks = document.querySelectorAll(
    '.productListHorizon > .productList, #productDetail > ul.img'
  );
  if (!tracks.length) return;

  tracks.forEach(initCarousel);

  function initCarousel(track){
    // ★ ここで判定（track が #productDetail > ul.img に該当するか？）
    const isDetailImg = track.matches('#productDetail > ul.img');

    // ラッパは「イベントを受ける要素」。副作用を避けるため track 自身に持たせる
    const wrap  = track;

    // “設定値の保管場所”として、まず track の dataset を見る。
    // もし .productListHorizon の直上コンテナがあれば、その dataset も fallback に使う。
    const container = track.closest('.productListHorizon') || track;

    // 子要素
    const items = Array.from(track.children);
    const n = items.length;

    // --- 設定取得（PC/SPの有効フラグ & 表示枚数） --------------------------
    const dsTrack = track.dataset || {};
    const dsCont  = container.dataset || {};

    // data-col-sp のタイプミス data-co-sp も許容
    const spCountAttr = dsTrack.colSp ?? dsTrack.coSp ?? dsCont.colSp ?? dsCont.coSp;
    const pcCountAttr = dsTrack.colPc ?? dsCont.colPc;

    const hasSP = spCountAttr !== undefined;     // そのビューポートで有効にできるか
    const hasPC = pcCountAttr !== undefined;

    const enabledForViewport = () => {
      const isPC = window.innerWidth >= breakpoint;
      return isPC ? !!hasPC : !!hasSP;
    };

    const getVisible = () => {
      const isPC = window.innerWidth >= breakpoint;
      if (isPC) {
        // PC: 有効なら指定枚数、無効なら全表示（= スライド無効）
        return hasPC ? (parseFloat(pcCountAttr) || 4) : n;
      } else {
        // SP: 有効なら指定枚数、無効なら全表示
        return hasSP ? (parseFloat(spCountAttr) || 2) : n;
      }
    };

    // ドットナビ有効？
    const wantDotnav = ('dotnav' in dsTrack) || ('dotnav' in dsCont);

    // 画像や a のネイティブドラッグ抑止
    track.addEventListener('dragstart', e => e.preventDefault());
    track.querySelectorAll('a,img').forEach(el => el.setAttribute('draggable','false'));

    // 状態
    let visible = getVisible();
    let maxIndex = Math.max(0, n - visible);
    let tx = 0;
    let startX = 0;
    let startTX = 0;
    let dragging = false;
    let pointerId = null;
    let currentIndex = 0;
    let moved = false;
    let suppressClick = false;
    let downAnchor = null;

    // ドットナビ
    let dotsRoot = null;
    const makeOrUpdateDots = () => {
      if (!wantDotnav) return;
      const pages = Math.max(1, maxIndex + 1);

      // 既存があれば再利用、なければ生成（track の直後）
      if (!dotsRoot) {
        dotsRoot = document.createElement('div');
        dotsRoot.className = 'carousel-dotnav';
        dotsRoot.setAttribute('role', 'tablist');
        track.after(dotsRoot);
      }

      // 既存数と差があれば作り直し
      const currentButtons = Array.from(dotsRoot.querySelectorAll('button'));
      if (currentButtons.length !== pages) {
        dotsRoot.innerHTML = '';
        for (let i = 0; i < pages; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-controls', '');
          b.setAttribute('aria-selected', 'false');
          b.addEventListener('click', () => snapTo(i));
          dotsRoot.appendChild(b);
        }
      }
      updateDotsActive();
    };
    const updateDotsActive = () => {
      if (!dotsRoot) return;
      const btns = dotsRoot.querySelectorAll('button.dot');
      btns.forEach((b, i) => {
        const active = i === currentIndex;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const samples = []; // {x,t}
    const itemWidth = () => wrap.clientWidth / visible;
    const minTX = () => -(n - visible) * itemWidth();
    const maxTX = () => 0;

    const clampIndex   = (i)  => Math.max(0, Math.min(maxIndex, i));
    const hardClampTX  = (px) => Math.min(maxTX(), Math.max(minTX(), px));

    function softClampDuringDrag(next){
      const leftLimit  = maxTX(); // 0
      const rightLimit = minTX(); // 負
      if (next > leftLimit) {
        const over = next - leftLimit;       // 正
        return leftLimit + over * edgeElasticity;
      }
      if (next < rightLimit) {
        const over = next - rightLimit;      // 負
        return rightLimit + over * edgeElasticity;
      }
      return next;
    }

    function setTX(px, ms = 0, easing = 'cubic-bezier(.2,.8,.2,1)'){
      if (ms > 0) {
        track.style.transition = `transform ${ms}ms ${easing}`;
        track.addEventListener('transitionend', () => {
          track.style.transition = 'none';
        }, { once: true });
      }
      tx = px;
      track.style.transform = `translate3d(${tx}px,0,0)`;
    }

    const indexFromTX = (px) => {
      const off = -px; // 左へどれだけ進んだか（正）
      return Math.round(off / itemWidth());
    };

    function snapTo(index, animateMs = snapDurationMs){
      currentIndex = clampIndex(index);
      setTX(-currentIndex * itemWidth(), animateMs);
      updateDotsActive();
    }

    function pushSample(x){
      const now = performance.now();
      samples.push({x, t: now});
      while (samples.length && now - samples[0].t > sampleWindowMs) samples.shift();
    }
    function getVelocity(){
      if (samples.length < 2) return 0;
      const a = samples[0], b = samples[samples.length - 1];
      const dt = b.t - a.t; if (dt <= 0) return 0;
      return (b.x - a.x) / dt; // px/ms（右+ / 左-）
    }

    function bounceToEdge(edgeTX, v = 0){
      let over = Math.abs(v) * overshootK;
      over = Math.max(overshootMin, Math.min(overshootMax, over));
      const dir = (edgeTX === maxTX()) ? +1 : -1;
      const outTX = edgeTX + dir * over;

      setTX(outTX, overshootOutMs, 'cubic-bezier(.2,.9,.2,1)');
      setTimeout(() => {
        setTX(edgeTX, overshootBackMs, 'cubic-bezier(.15,.85,.2,1)');
      }, overshootOutMs);
    }

    // ドラッグだったときだけ click を抑止
    wrap.addEventListener('click', (e) => {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    function onPointerDown(e){
      // 無効ビューポートではクリックのみ通す
      if (!enabledForViewport() || maxIndex === 0) return;

      if (e.pointerType === 'mouse' && e.button !== 0) return; // 左クリックのみ
      dragging = true;
      pointerId = e.pointerId;
      wrap.classList.add('grabbing');

      startX = e.clientX;
      startTX = tx;
      samples.length = 0;
      pushSample(startX);

      moved = false;
      suppressClick = false;
      downAnchor = e.target.closest('a');
    }

    function onPointerMove(e){
      if (!dragging || e.pointerId !== pointerId) return;
      const dx = e.clientX - startX;

      if (!moved && Math.abs(dx) > clickThreshold) {
        moved = true;
        suppressClick = true;
        wrap.setPointerCapture(pointerId);
      }

      const next = softClampDuringDrag(startTX + dx);
      setTX(next, 0);
      pushSample(e.clientX);

      if (moved) e.preventDefault();
    }

    function onPointerUp(e){
      if (!dragging || e.pointerId !== pointerId) return;
      dragging = false;
      try { wrap.releasePointerCapture(pointerId); } catch(_) {}
      wrap.classList.remove('grabbing');

      if (!moved) {
        suppressClick = false;
        if (downAnchor && downAnchor.href) {
          setTimeout(() => { window.location.href = downAnchor.href; }, 0);
        }
        return;
      }

      const dxTotal = tx - startTX;          // 左が負（次へ進む方向）
      const v = getVelocity();               // px/ms（右+ / 左-）
      const w = itemWidth();
      const movedRatio = Math.abs(dxTotal) / w;

      // --- ★ 安定化モード：#productDetail > ul.img のみ ---
      if (isDetailImg) {
        // デフォルト or data-属性で上書き
        const ds = track.dataset;
        const distThresh = parseFloat(ds.flickDistance ?? '0.25');  // 25% 以上動いたら
        const velThresh  = parseFloat(ds.flickVelocity ?? '0.28');  // 0.28 px/ms ≒ 280px/s
        const maxJump    = Math.max(1, parseInt(ds.flickMaxjump ?? '1', 10)); // 1 or 2 推奨

        // 進行方向（速度優先、ゼロなら距離符号）
        const dir = (Math.abs(v) > 0.0001) ? (v < 0 ? +1 : -1) : (dxTotal < 0 ? +1 : -1);

        let steps = 0;
        if (movedRatio >= distThresh || Math.abs(v) >= velThresh) {
          // 基本は1枚、かなり速いときのみ最大2枚まで
          steps = 1;
          if (Math.abs(v) >= velThresh * 2) steps = Math.min(2, maxJump);
          steps = Math.min(steps, maxJump);
        } else {
          steps = 0; // しきい値未満 → その場に留まる
        }

        const target = clampIndex(currentIndex + dir * steps);
        if (target === 0 && tx > maxTX()) {
          bounceToEdge(maxTX(), v);
        } else if (target === maxIndex && tx < minTX()) {
          bounceToEdge(minTX(), v);
        } else {
          snapTo(target);
        }

        e.preventDefault();
        setTimeout(() => { suppressClick = false; }, 0);
        return;
      }

      // --- 通常モード（既存ロジックのまま：慣性あり） ---
      const projected = hardClampTX(tx + v * inertiaFactor);
      let target = indexFromTX(projected);

      if (Math.abs(dxTotal) < dragDistanceThreshold && Math.abs(v) < velocityThreshold){
        target = indexFromTX(tx);
      }

      const EPS = 0.5;
      const overLeft  = tx > maxTX() + EPS;
      const overRight = tx < minTX() - EPS;
      if (overLeft) {
        bounceToEdge(maxTX(), v);
      } else if (overRight) {
        bounceToEdge(minTX(), v);
      } else {
        snapTo(target);
      }

      e.preventDefault();
      setTimeout(() => { suppressClick = false; }, 0);
    }

    function onResize(){
      const prevVisible = visible;
      visible = getVisible();
      maxIndex = Math.max(0, n - visible);

      // 現在の先頭indexを保つ
      const idx = clampIndex(indexFromTX(hardClampTX(tx)));
      setTX(-idx * itemWidth(), 0);
      currentIndex = idx;

      // 見た目用クラス切り替え
      wrap.classList.toggle('is-carousel-enabled', enabledForViewport() && maxIndex > 0);

      // ドット更新
      makeOrUpdateDots();
    }

    // 初期化
    wrap.classList.toggle('is-carousel-enabled', enabledForViewport() && maxIndex > 0);
    makeOrUpdateDots();

    const ro = new ResizeObserver(onResize);
    ro.observe(wrap);
    window.addEventListener('orientationchange', onResize);
    window.addEventListener('resize', onResize);

    wrap.addEventListener('pointerdown', onPointerDown, { passive: false });
    wrap.addEventListener('pointermove', onPointerMove, { passive: false });
    wrap.addEventListener('pointerup', onPointerUp, { passive: false });
    wrap.addEventListener('pointercancel', onPointerUp, { passive: false });

    // キーボード操作（フォーカス時）
    wrap.tabIndex = 0;
    wrap.addEventListener('keydown', (e) => {
      if (!enabledForViewport() || maxIndex === 0) return;
      if (e.key === 'ArrowRight') snapTo(currentIndex + 1);
      if (e.key === 'ArrowLeft')  snapTo(currentIndex - 1);
      if (wantDotnav && (e.key === 'Home')) snapTo(0);
      if (wantDotnav && (e.key === 'End'))  snapTo(maxIndex);
    });
  }
})();

// .fullSlider 専用 フル幅スナップカルーセル
(() => {
  const snapDurationMs = 320;
  const dragDistanceThreshold = 20;  // px
  const velocityThreshold = 0.5;     // px/ms
  const inertiaFactor = 220;         // 慣性距離 = 速度 * 係数
  const sampleWindowMs = 120;
  const clickThreshold = 6;

  const edgeElasticity = 0.35;
  const overshootMin = 18;
  const overshootMax = 60;
  const overshootK   = 400;
  const overshootOutMs = 140;
  const overshootBackMs = 220;

  const sliders = document.querySelectorAll('.fullSlider');
  if (!sliders.length) return;

  sliders.forEach(initFullSlider);

  function initFullSlider(root){
    // すでに初期化済みならスキップ
    if (root.__fullSliderInited) return;
    root.__fullSliderInited = true;

    // 元の子要素（スライド達）を track に包む
    const slides = Array.from(root.children);
    const track = document.createElement('div');
    track.className = 'fullSlider__track';
    // 画像/リンクのネイティブドラッグを抑止
    slides.forEach(s => s.querySelectorAll('a,img').forEach(el => el.setAttribute('draggable','false')));
    slides.forEach(s => track.appendChild(s));
    root.appendChild(track);

    // コントロールUI（左右ボタン & ドット）
    const btnPrev = document.createElement('button');
    btnPrev.type = 'button';
    btnPrev.className = 'fullSlider__prev';
    btnPrev.setAttribute('aria-label', '前のスライドへ');

    const btnNext = document.createElement('button');
    btnNext.type = 'button';
    btnNext.className = 'fullSlider__next';
    btnNext.setAttribute('aria-label', '次のスライドへ');

    const dotnav = document.createElement('div');
    dotnav.className = 'fullSlider__dotnav';
    dotnav.setAttribute('role','tablist');

    root.append(btnPrev, btnNext, dotnav);

    // 状態
    const n = slides.length;
    let tx = 0;
    let startX = 0;
    let startTX = 0;
    let dragging = false;
    let pointerId = null;
    let currentIndex = 0;
    let moved = false;
    let suppressClick = false;
    let downAnchor = null;

    const samples = []; // {x,t}

    // ドット生成
    const dots = [];
    function buildDots(){
      dotnav.innerHTML = '';
      for (let i = 0; i < n; i++){
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fullSlider__dot';
        b.setAttribute('role','tab');
        b.setAttribute('aria-selected', 'false');
        b.addEventListener('click', () => snapTo(i));
        dotnav.appendChild(b);
        dots.push(b);
      }
      updateDots();
    }
    function updateDots(){
      dots.forEach((b, i) => {
        const active = i === currentIndex;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    // ボタンの表示/無効化
    function updateButtons(){
      btnPrev.disabled = (currentIndex === 0);
      btnNext.disabled = (currentIndex === n - 1);
      btnPrev.classList.toggle('is-hidden', currentIndex === 0);
      btnNext.classList.toggle('is-hidden', currentIndex === n - 1);
    }

    // 速度サンプル
    function pushSample(x){
      const now = performance.now();
      samples.push({x, t: now});
      while (samples.length && now - samples[0].t > sampleWindowMs) samples.shift();
    }
    function getVelocity(){
      if (samples.length < 2) return 0;
      const a = samples[0], b = samples[samples.length - 1];
      const dt = b.t - a.t; if (dt <= 0) return 0;
      return (b.x - a.x) / dt; // px/ms（右+ / 左-）
    }

    // 幾何
    const itemWidth = () => root.clientWidth;          // 1画面 = 1スライド
    const minTX = () => -(n - 1) * itemWidth();        // 最後まで
    const maxTX = () => 0;                             // 先頭
    const hardClampTX = (px) => Math.min(maxTX(), Math.max(minTX(), px));
    const clampIndex = (i) => Math.max(0, Math.min(n - 1, i));

    function softClampDuringDrag(next){
      const leftLimit  = maxTX();
      const rightLimit = minTX();
      if (next > leftLimit) {
        const over = next - leftLimit;
        return leftLimit + over * edgeElasticity;
      }
      if (next < rightLimit) {
        const over = next - rightLimit;
        return rightLimit + over * edgeElasticity;
      }
      return next;
    }

    function setTX(px, ms = 0, easing = 'cubic-bezier(.2,.8,.2,1)'){
      if (ms > 0) {
        track.style.transition = `transform ${ms}ms ${easing}`;
        track.addEventListener('transitionend', () => {
          track.style.transition = 'none';
        }, { once: true });
      }
      tx = px;
      track.style.transform = `translate3d(${tx}px,0,0)`;
    }

    function indexFromTX(px){
      const off = -px; // 左へどれだけ進んだか（正）
      return Math.round(off / itemWidth());
    }

    function snapTo(index, ms = snapDurationMs){
      currentIndex = clampIndex(index);
      setTX(-currentIndex * itemWidth(), ms);
      updateDots();
      updateButtons();
    }

    // クリック抑止（ドラッグ時のみ）
    root.addEventListener('click', (e) => {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // ポインタイベント
    function onPointerDown(e){
      if (n <= 1) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      pointerId = e.pointerId;

      startX = e.clientX;
      startTX = tx;
      samples.length = 0;
      pushSample(startX);

      moved = false;
      suppressClick = false;
      downAnchor = e.target.closest('a');
      root.classList.add('is-grabbing');
    }
    function onPointerMove(e){
      if (!dragging || e.pointerId !== pointerId) return;
      const dx = e.clientX - startX;

      if (!moved && Math.abs(dx) > clickThreshold) {
        moved = true;
        suppressClick = true;
        root.setPointerCapture(pointerId);
      }

      const next = softClampDuringDrag(startTX + dx);
      setTX(next, 0);
      pushSample(e.clientX);
      if (moved) e.preventDefault();
    }
    function bounceTo(edgeTX, v = 0){
      let over = Math.abs(v) * overshootK;
      over = Math.max(overshootMin, Math.min(overshootMax, over));
      const dir = (edgeTX === maxTX()) ? +1 : -1;
      const outTX = edgeTX + dir * over;
      setTX(outTX, overshootOutMs, 'cubic-bezier(.2,.9,.2,1)');
      setTimeout(() => setTX(edgeTX, overshootBackMs, 'cubic-bezier(.15,.85,.2,1)'), overshootOutMs);
    }
    function onPointerUp(e){
      if (!dragging || e.pointerId !== pointerId) return;
      dragging = false;
      try { root.releasePointerCapture(pointerId); } catch(_) {}
      root.classList.remove('is-grabbing');

      if (!moved) {
        suppressClick = false;
        if (downAnchor && downAnchor.href) {
          setTimeout(() => { window.location.href = downAnchor.href; }, 0);
        }
        return;
      }

      const dxTotal = tx - startTX; // 左が負（次へ）
      const v = getVelocity();
      const w = itemWidth();

      const movedRatio = Math.abs(dxTotal) / w;    // 画面幅に対する移動割合
      const distThresh = 0.18;                     // 18% くらい動いたらスライド
      const velThresh  = 0.25;                     // ある程度の速度でもスライド

      const dir = dxTotal < 0 ? +1 : -1;           // 左にスワイプ → +1 スライド進める

      let target = currentIndex;
      if (movedRatio >= distThresh || Math.abs(v) >= velThresh) {
        target = clampIndex(currentIndex + dir);
      }

      // 端ではバウンス（お好みで）
      if (target === 0 && tx > maxTX()) {
        bounceTo(maxTX(), v);
      } else if (target === n - 1 && tx < minTX()) {
        bounceTo(minTX(), v);
      } else {
        snapTo(target);
      }

      e.preventDefault();
      setTimeout(() => { suppressClick = false; }, 0);
    }


    // ボタン操作
    btnPrev.addEventListener('click', () => snapTo(currentIndex - 1));
    btnNext.addEventListener('click', () => snapTo(currentIndex + 1));

    // キーボード（フォーカス時）
    root.tabIndex = 0;
    root.addEventListener('keydown', (e) => {
      if (n <= 1) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); snapTo(currentIndex + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); snapTo(currentIndex - 1); }
      if (e.key === 'Home')       { e.preventDefault(); snapTo(0); }
      if (e.key === 'End')        { e.preventDefault(); snapTo(n - 1); }
    });

    // リサイズ
    const onResize = () => {
      // 今の index を保ったまま幅再計算
      setTX(-clampIndex(currentIndex) * itemWidth(), 0);
    };
    const ro = new ResizeObserver(onResize);
    ro.observe(root);
    window.addEventListener('orientationchange', onResize);
    window.addEventListener('resize', onResize);

    // 初期化
    // track の最低限のスタイルは JS 側で付与（既存CSSに依存しないように）
    Object.assign(track.style, {
      display: 'flex',
      width: '100%',
      willChange: 'transform'
    });
    slides.forEach(s => Object.assign(s.style, { minWidth: '100%' }));

    buildDots();
    // スライドが1枚しかなければコントロール非表示
    const controlsHidden = (n <= 1);
    btnPrev.style.display = controlsHidden ? 'none' : '';
    btnNext.style.display = controlsHidden ? 'none' : '';
    dotnav.style.display  = controlsHidden ? 'none' : '';

    snapTo(0, 0);

    // ドラッグ抑止
    track.addEventListener('dragstart', e => e.preventDefault());
    root.addEventListener('pointerdown', onPointerDown, { passive: false });
    root.addEventListener('pointermove', onPointerMove, { passive: false });
    root.addEventListener('pointerup', onPointerUp, { passive: false });
    root.addEventListener('pointercancel', onPointerUp, { passive: false });
  }
})();



document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".productInfo").forEach(info => {
    const btn = info.querySelector(".toggleBtn");
    const content = info.querySelector(".toggleContent");

    btn.addEventListener("click", () => {
      info.classList.toggle("open");
    });
  });
});